import { connect } from 'react-redux';
import { determineWhichFlow } from '../../../../../flows/DynamicFlow/utilities/helpers';
import {
  getCheckinDateSelection,
  getCheckoutDateSelection,
  getTotalNumberOfNights
} from '../../../../../store/componentStores/Dates/dates.selectors';
import { openModal } from '../../../../../store/componentStores/GlobalModal/globalModal.actions';
import {
  getAdultsCount,
  getKidsAges,
  getKidsCount,
  getNumberOfGuests
} from '../../../../../store/componentStores/Guests/guests.selectors';
import {
  getHiddenOfferPrefixesFromState,
  getIsCartActive,
  getIsHighestRatesEnabled,
  getIsTaxOnlyMessage,
  getLoyaltyEarnThresholdNights,
  getPointsMultiplier,
  getSuitePriceIncludedTaxesAndFees
} from '../../../../../store/componentStores/LodgeConfig/lodgeConfig.selectors';
import {
  clearPlanPackages,
  clearSelectedPackages,
  deletePackage,
  upsertPackage
} from '../../../../../store/componentStores/Packages/packages.actions';
import {
  getPackagesGrossTotal,
  getSelectedPackages
} from '../../../../../store/componentStores/Packages/packages.selectors';
import {
  setCartReturnedPageLinkClicked,
  setIsCartOpenClose
} from '../../../../../store/componentStores/Plans/plans.actions';
import { clearSelectedSuite } from '../../../../../store/componentStores/Suite/suite.actions';
import {
  getPromotionalSavings,
  getRateType,
  getRoomAdjustmentTax,
  getSelectedSuite,
  getSuiteHeadline
} from '../../../../../store/componentStores/Suite/suite.selectors';
import {
  getEffectiveLoggedInForFlex,
  getFlexAwareDueAtCheckinAmount,
  getFlexAwareDueTodayAmount,
  getFlexAwareSuiteTotal,
  getFlexAwareSummaryTotal,
  getFlexAwareTaxesAndFees,
  getGrossSummaryTotal,
  getValidOfferCode,
  showLoyalty
} from '../../../../../store/reducers';

import {
  getUserIsLoggedIn,
  getUserLoyaltyOptIn,
  getUserLoyaltyPointsAmount,
  getUserLoyaltyPointsBalance,
  getUserOffers
} from '../../../../../store/componentStores/Account/account.selectors';
import {
  pushToLastVisitedStep,
  resetCartResortLocation,
  setExpiredCart
} from '../../../../../store/componentStores/Cart/cart.actions';
import {
  getCartLastVisitedStep,
  getCartResortLocation,
  getExpiredCart
} from '../../../../../store/componentStores/Cart/cart.selectors';
import { getResortLocation } from '../../../../../store/componentStores/CurrentLodge/currentLodge.selectors';
import {
  getChangeFee,
  getReservationId
} from '../../../../../store/componentStores/ManageReservation/manageReservation.selectors';
import { removeActiveOffer } from '../../../../../store/componentStores/Offer/offer.actions';
import {
  getActiveOffers,
  getDefaultOfferCode,
  getEmailActiveOffers,
  getIsOfferAppliedViaPromoBanner
} from '../../../../../store/componentStores/Offer/offer.selectors';
import {
  getCartReturnedPageLinkClicked,
  getIsCartOpenClose,
  getIsChangedToFlex,
  getSavePointsForLater
} from '../../../../../store/componentStores/Plans/plans.selectors';
import { DATE_FORMATS } from '../../../../../utilities/constants';
import { getDateMonthDayFormat } from '../../../../../utilities/dates';
import { getGuestCountLabel } from '../../../../../utilities/guestsUtils';
import { getResortLocationUrl } from '../../../../../utilities/lodgeData';
import { checkIfIsNiagaraProperty } from '../../../../../utilities/navigationUtils';
import { GwDatesWrapper } from '../../../../_internal_date_/gwDatesWrapper';
import { SUMMARY_CART_VARIATIONS } from '../utilities/constants';
import { Summary } from './Summary';

const mapStateToProps = (state, { variation, flowName }) => {
  const { isModifyFlow } = determineWhichFlow(flowName);

  const { pathname } = state?.router?.location ?? null;

  const onPaymentPage = pathname.includes('/payment');
  const avoidCartLogoRender = onPaymentPage;

  const cmpUrls = ['confirmation', /my-reservations\/[\w\d]+/];
  const onCmpPage = cmpUrls.some(keyword => {
    if (keyword instanceof RegExp) {
      return keyword.test(pathname);
    }
    return pathname.includes(keyword);
  });

  const onPlanPage = pathname.includes('/plan');
  const onBirthDayPage = pathname.includes('/birthday-parties');
  const onDaypassPage = pathname.includes('/daypass');
  const onSeasonpassPage = pathname.includes('/seasonpass');

  const selectedPackages = getSelectedPackages(state.packages);

  const taxesAndFees = getFlexAwareTaxesAndFees(state);

  /* ABCD TEST FOR PARKING FEE */

  const resortLocation = getResortLocation(state.currentLodge);

  return {
    checkIn:
      variation === SUMMARY_CART_VARIATIONS.CART
        ? GwDatesWrapper.format(getCheckinDateSelection(state.dates), DATE_FORMATS.monthDayYear)
        : getDateMonthDayFormat(getCheckinDateSelection(state.dates)),
    checkOut:
      variation === SUMMARY_CART_VARIATIONS.CART
        ? GwDatesWrapper.format(getCheckoutDateSelection(state.dates), DATE_FORMATS.monthDayYear)
        : getDateMonthDayFormat(getCheckoutDateSelection(state.dates)),
    currentSelectedPackages: selectedPackages,
    dueTodayAmount: getFlexAwareDueTodayAmount(state),
    dueAtCheckinAmount: getFlexAwareDueAtCheckinAmount(state),
    guestCountText: getGuestCountLabel(getAdultsCount(state.guests), getKidsCount(state.guests), variation),
    hasAdditionalCharges: taxesAndFees && taxesAndFees.length > 0,
    hasSelectedPackages: selectedPackages && selectedPackages.length > 0,
    isNiagaraProperty: checkIfIsNiagaraProperty(resortLocation),
    rateType: getRateType(state.suite),
    userIsLoggedIn: getUserIsLoggedIn(state.account),
    numberOfGuests: getNumberOfGuests(state.guests),
    numberOfNights: getTotalNumberOfNights(state.dates),
    onPaymentPage: onPaymentPage,
    packagesTotal: getPackagesGrossTotal(state.packages),
    promoCode: getValidOfferCode(state),
    promotionalSavings: getPromotionalSavings(state.suite),
    suiteTitle: getSuiteHeadline(state.suite),
    suiteTotal: getFlexAwareSuiteTotal(state),
    summaryTotal: onPaymentPage ? getFlexAwareSummaryTotal(state) : getGrossSummaryTotal(state),
    taxesAndFees: taxesAndFees,
    pointsBalance: getUserLoyaltyPointsBalance(state.account),
    loyaltyOptIn: getUserLoyaltyOptIn(state.account),
    showLoyalty: showLoyalty(state),
    userOffers: getUserOffers(state.account),
    activeOffers: getActiveOffers(state.offer),
    emailActiveOffers: getEmailActiveOffers(state.offer),
    isUserAuthenticated: getUserIsLoggedIn(state.account),
    getPointsMultiplier: getPointsMultiplier(state.lodgeConfig),
    roomAdjustmentTax: getRoomAdjustmentTax(state),
    offerCode: getDefaultOfferCode(state.offer),
    resortLocation,
    selectedSuite: getSelectedSuite(state.suite),
    resortLocationUrlParam: getResortLocationUrl(),
    onCmpPage,
    onPlanPage,
    onBirthDayPage,
    onDaypassPage,
    onSeasonpassPage,
    isCartOpenClose: getIsCartOpenClose(state.plans),
    cartReturnedPageLinkClicked: getCartReturnedPageLinkClicked(state.plans),
    isCartVariation: variation === SUMMARY_CART_VARIATIONS.CART && getIsCartActive(state.lodgeConfig),
    cartResortLocation: getCartResortLocation(state.cart),
    cartLastVisitedStep: getCartLastVisitedStep(state.cart),
    isCartExpired: getExpiredCart(state.cart),
    adultsCount: getAdultsCount(state.guests),
    kidsAges: getKidsAges(state.guests),
    arrival: getCheckinDateSelection(state.dates),
    departure: getCheckoutDateSelection(state.dates),
    loyaltyEarnThresholdNights: getLoyaltyEarnThresholdNights(state.lodgeConfig),
    kidsCount: getKidsCount(state.guests),
    isHighestRatesEnabled: getIsHighestRatesEnabled(state.lodgeConfig),
    avoidCartLogoRender,
    changeFee: getChangeFee(state.entities.manageReservationDetails),
    isTaxOnlyMessage: getIsTaxOnlyMessage(state.lodgeConfig),
    reservationId: getReservationId(state.entities.manageReservationDetails),
    isModifyFlow,
    hiddenOfferPrefixes: getHiddenOfferPrefixesFromState(state.lodgeConfig),
    appliedViaPromoBanner: getIsOfferAppliedViaPromoBanner(state.offer),
    savePointsForLater: getSavePointsForLater(state.plans),
    pointAmount: getUserLoyaltyPointsAmount(state.account),
    isChangedToFlex: getIsChangedToFlex(state.plans),
    effectiveIsLoggedInForFlex: getEffectiveLoggedInForFlex(state),
    suitePriceIncludedTaxesAndFees: getSuitePriceIncludedTaxesAndFees(state.lodgeConfig)
  };
};

const mapDispatchToProps = {
  upsertPackage,
  deletePackage,
  clearPlanPackages,
  clearSelectedPackages,
  openModal,
  resetCartResortLocation: resetCartResortLocation,
  pushToLastVisitedStep: pushToLastVisitedStep,
  setExpiredCart: setExpiredCart,
  setIsCartOpenClose,
  setCartReturnedPageLinkClicked,
  clearSelectedSuite,
  removeActiveOffer
};

const PlanSummary = connect(mapStateToProps, mapDispatchToProps)(Summary);

export { PlanSummary };
